module.exports = __webpack_public_path__ + "static/media/APIExposeIconActive.61727ad8.png";